export default __webpack_public_path__ + "static/media/3.0508296a.svg";